import { ChangeDetectorRef, Component, OnInit, Input, inject, input, computed, signal, Signal, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { IBrandCard } from '../../../types';
import { HomeService } from '../home.service';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { BucketPipe } from '../../../bucket.pipe';
import { ImageFallbackDirective } from '../../../image-fallback.directive';
import { CacheService } from '../../../auth.service';

@Component({
  selector: 'brands-dialog',
  templateUrl: './brands-dialog.component.html',
  styleUrls: ['./brands-dialog.component.scss'],
  imports: [MatIconModule, RouterLink, MatButtonModule, MatDialogClose, BucketPipe, ImageFallbackDirective],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [HomeService]
})
export class BrandsDialogComponent implements OnInit {

  home = inject(HomeService);
  detector = inject(ChangeDetectorRef);
  dialogRef = inject(MatDialogRef<MatDialog>); 
  cache = inject(CacheService);

  brands = input<IBrandCard[]>([]);
  loadedBrands = signal<IBrandCard[]>([]);
  index: number = 0;

  items = computed(() => {
    return this.loadedBrands()?.length ? this.loadedBrands() : this.brands();
  });

  ngOnInit(): void {
    this.home.getBrandsList().subscribe({
      next: value => {

        const brands = 'brands' in value ? value.brands : value;

        if('plans' in value){
          this.cache.registerPlans(value.plans);
        }
        this.loadedBrands.set(brands || []);
      },
      error: error => {

      }
    });
  }
}
